import enrollment from '@/api/student-enrollment'
import student from '@/api/student-profile'

import { baseState, baseMutations } from '@/store/mixins'
import { join } from 'lodash'

export const state = {
  ...baseState,
  edit_data: {},
  classOperations: [],
  student_status_id: [],
  status: [1],
  // ac_status_id: [],
  ac_status_id: 1,
  ac_year_id: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_STATUS_VALUE(state, value) {
    state.status = value
  },
  SET_ACADEMIC_YEAR_VALUE(state, value) {
    state.ac_year_id = value
  },
  SET_STUDENT_STATUS_VALUE(state, value) {
    state.student_status_id = value.length > 0 ? value : [1]
  },
  SET_AC_STATUS(state, acStatusId) {
    state.ac_status_id = acStatusId
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        student_status_id: context.state.student_status_id,
        ac_year: context.state.ac_year_id,
        filter: {
          ac_status_id: join(context.state.status, ',')
        }
      },
      attrubutes
    )
    return enrollment.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return enrollment.store(data)
  },

  update(context, data) {
    return enrollment.update(data)
  },
  destroy(context, id) {
    return enrollment.destroy(id)
  },
  storeStudentForward(context, data) {
    return enrollment.forwardClass(data)
  },
  accelerateStudent(context, data) {
    return enrollment.accelerateStudent(data)
  },

  async getClassOperation(context, attrubutes = {}) {
    let params = Object.assign(
      {
        filter: {
          ac_status_id: context.state.ac_status_id
        }
      },
      attrubutes
    )
    return await enrollment.getClass({ params })
  },
  async getStudent(context, params = {}) {
    return await enrollment.getStudent({ params })
  },
  fetchStudentEnrollByClass(context, attrubutes = {}) {
    return enrollment.get({ params: attrubutes })
  },
  getClassOfNextGrade(context, { gradeId, params }) {
    return enrollment.getClassOfNextGrade({ gradeId, params })
  },

  findRoomCapacity(context,classId) {
    return enrollment.findRoomCapacity(classId)
  }
}
